/* SHC — Cart drawer live-update logic.
   Subscribes to the theme's cart-update pub/sub event and keeps the free
   shipping progress bar + live-priced checkout button in sync without
   requiring a full drawer re-render on every change.
*/
(function () {
  'use strict';

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function updateProgress(cart) {
    var el = document.querySelector('[data-shc-progress]');
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-shc-threshold') || '8500', 10);
    var total = cart.total_price;
    var remaining = Math.max(0, threshold - total);
    var progress = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;

    el.setAttribute('data-shc-total', total);
    el.setAttribute('data-shc-complete', remaining === 0 ? '1' : '0');

    var fill = el.querySelector('[data-shc-progress-fill]');
    if (fill) fill.style.width = progress + '%';

    var truck = el.querySelector('[data-shc-progress-truck]');
    if (truck) truck.style.left = progress + '%';

    var msg = el.querySelector('[data-shc-progress-msg]');
    if (msg) {
      if (remaining === 0) {
        msg.innerHTML = '🎉 You\'ve unlocked <strong>free shipping</strong>!';
      } else {
        msg.innerHTML = 'Only <strong data-shc-progress-remaining>' + formatMoney(remaining) +
          '</strong> away from <strong>free shipping</strong>.';
      }
    }

    var track = el.querySelector('.shc-progress__track');
    if (track) track.setAttribute('aria-valuenow', progress);
  }

  function updateCheckoutButton(cart) {
    document.querySelectorAll('[data-shc-checkout-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
  }

  function updateItemCount(cart) {
    document.querySelectorAll('[data-shc-item-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function refreshFromCart(cart) {
    if (!cart) return;
    try { updateProgress(cart); } catch (e) { /* silent */ }
    try { updateCheckoutButton(cart); } catch (e) { /* silent */ }
    try { updateItemCount(cart); } catch (e) { /* silent */ }
  }

  function fetchAndRefresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshFromCart(cart); })
      .catch(function () { /* silent */ });
  }

  // Subscribe to Dawn's pub/sub cart-update event. `publish()` from constants.js.
  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      // Payload from Dawn is Shopify's /cart/add.js response shape (single line item),
      // not the full cart. Always fetch the current cart for the summary values.
      fetchAndRefresh();
    });
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () { fetchAndRefresh(); });
    return true;
  }

  if (!bind()) {
    // pubsub may load later — retry once DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function () { bind(); fetchAndRefresh(); });
  } else {
    fetchAndRefresh();
  }


  // ---- Express checkout row: three wallets, fitted to the drawer.
  // PayPal will not render below ~150px and ignores the width property, so the
  // row is laid out at its natural size and scaled down as a unit. Shopify also
  // does not fill the container it is handed, so once it settles we measure the
  // real content edges and rescale to span the drawer.
  //
  // The settled result is cached per (wallet count, drawer width). iOS fires a
  // resize on every scroll as the URL bar collapses, and recomputing on each
  // one is what made the row shrink while scrolling and jump back after.
  var EXPRESS_WALLETS = 'shop-pay-wallet-button, apple-pay-wallet-button,' +
                        'shopify-apple-pay-button, shopify-paypal-button,' +
                        'shopify-google-pay-button, google-pay-wallet-button';
  var APPLE = 'apple-pay-wallet-button, shopify-apple-pay-button';
  var ONE_ROW_MAX = 110; // a single row of buttons is ~75px tall

  function expressParts() {
    var wrap = document.querySelector('.shc-express');
    if (!wrap || !wrap.firstElementChild) return null;
    return { wrap: wrap, inner: wrap.firstElementChild };
  }

  function walletCount(wrap, inner) {
    // Three wallets maximum: Apple Pay takes the middle slot where it exists
    // (Safari/iOS), Google Pay takes it everywhere else.
    var apple = inner.querySelector(APPLE);
    wrap.classList.toggle('shc-express--hide-gpay', !!(apple && apple.getClientRects().length));
    var found = inner.querySelectorAll(EXPRESS_WALLETS);
    var n = 0;
    for (var i = 0; i < found.length; i++) {
      if (found[i].getClientRects().length) n++;
    }
    return n;
  }

  function contentEdges(inner) {
    var wallets = inner.querySelectorAll(EXPRESS_WALLETS);
    var left = Infinity, right = -Infinity;
    for (var i = 0; i < wallets.length; i++) {
      var r = wallets[i].getBoundingClientRect();
      if (!r.width) continue;
      left = Math.min(left, r.left);
      right = Math.max(right, r.right);
    }
    return left === Infinity ? null : { left: left, right: right };
  }

  function applyExpress(wrap, inner, natural, scale, tx, height) {
    inner.style.width = natural + 'px';
    wrap.style.setProperty('--shc-express-scale', scale.toFixed(4));
    wrap.style.setProperty('--shc-express-tx', tx.toFixed(1) + 'px');
    wrap.style.height = height + 'px';
  }

  function fitExpressRow() {
    var p = expressParts();
    if (!p) return;
    var wrap = p.wrap, inner = p.inner;
    var available = wrap.clientWidth;
    if (!available) return;
    var n = walletCount(wrap, inner);
    if (!n) return;

    // Already solved for this shape — re-assert it without the intermediate
    // size ever being painted.
    var done = wrap.__shcSettled;
    if (done && done.n === n && done.available === available) {
      if (wrap.style.getPropertyValue('--shc-express-scale') !== done.scale.toFixed(4)) {
        applyExpress(wrap, inner, done.natural, done.scale, done.tx, done.height);
      }
      return;
    }

    var pending = wrap.__shcPending;
    if (pending && pending.n === n && pending.available === available) return;
    wrap.__shcPending = { n: n, available: available };

    var natural = n * 150 + (n - 1) * 13 + 20;
    var scale = Math.min(1, available / natural);
    applyExpress(wrap, inner, natural, scale, 0, Math.ceil(56 * scale));
    setTimeout(function () { settleExpressRow(n, available); }, 400);
  }

  function settleExpressRow(n, available) {
    var p = expressParts();
    if (!p) return;
    var wrap = p.wrap, inner = p.inner;
    var natural = parseFloat(inner.style.width) || 476;

    // Shopify falls back to a vertical stack when it judges the row too tight,
    // and its internal gap is not the one we set, so widen until it is one row.
    for (var t = 0; t < 4 && inner.offsetHeight > ONE_ROW_MAX; t++) {
      natural += 60;
      inner.style.width = natural + 'px';
    }

    var scale = Math.min(1, available / natural);
    wrap.style.setProperty('--shc-express-scale', scale.toFixed(4));

    // Rescale so the buttons themselves span the drawer, not the container.
    var e = contentEdges(inner);
    if (e) {
      var contentNatural = (e.right - e.left) / scale;
      if (contentNatural > 0) {
        scale = Math.min(1, available / contentNatural);
        wrap.style.setProperty('--shc-express-scale', scale.toFixed(4));
      }
    }

    var height = Math.ceil(56 * scale);
    wrap.style.height = height + 'px';

    // Centre whatever rounding is left over.
    var tx = 0;
    e = contentEdges(inner);
    if (e) {
      var wr = wrap.getBoundingClientRect();
      tx = ((wr.width - (e.right - e.left)) / 2) - (e.left - wr.left);
      wrap.style.setProperty('--shc-express-tx', tx.toFixed(1) + 'px');
    }

    wrap.__shcSettled = { n: n, available: available, natural: natural,
                          scale: scale, tx: tx, height: height };
    wrap.__shcPending = null;
  }

  function watchExpressRow() {
    fitExpressRow();
    var p = expressParts();
    if (!p || p.wrap.__shcWatched) return;
    p.wrap.__shcWatched = true;
    // Wallets render, and re-render, long after load. Our own writes are style
    // attributes, not child changes, so this cannot feed back on itself.
    new MutationObserver(fitExpressRow).observe(p.wrap, { childList: true, subtree: true });
  }

  var expressResizeTimer;
  window.addEventListener('resize', function () {
    var p = expressParts();
    if (!p) return;
    // Width is what matters. iOS changes only the height while scrolling.
    if (p.wrap.__shcSettled && p.wrap.__shcSettled.available === p.wrap.clientWidth) return;
    clearTimeout(expressResizeTimer);
    expressResizeTimer = setTimeout(function () {
      p.wrap.__shcSettled = null;
      p.wrap.__shcPending = null;
      fitExpressRow();
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', watchExpressRow);
  document.addEventListener('click', function (e) {
    if (e.target && (e.target.closest('#cart-icon-bubble') || e.target.closest('a[href="/cart"]') || e.target.closest('[data-shc-atc]'))) {
      setTimeout(watchExpressRow, 250);
    }
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(watchExpressRow, 250); });
  }
  watchExpressRow();

})();
